import { TaxPartnerInfo } from 'generated/graphql';

export const userTaxPartnerInfoList = () => {
  return [
    { id: TaxPartnerInfo.Confirmed, name: 'Мой налог принят' },
    { id: TaxPartnerInfo.NotConfirmed, name: 'Мой налог не принят' },
    { id: TaxPartnerInfo.NotChecked, name: 'Мой налог не просмотрен' },
  ];
};
